module.exports = __webpack_public_path__ + "img/item-4.eb7ff7a.png";